import Organization from '@/views/Organization'
import Branch from '@/views/Branches'
import OrganizationUserProfile from '@/views/OrganizationUserProfile';
import PaymentIndex from '@/components/payment/PaymentIndex';
import PaymentDetail from '@/components/payment/PaymentDetail';
import CancelSubscription from '@/components/payment/CancelSubscription';

export default[{
  path: '/organization/:organizationId/',
  name: 'organization',
  component: Organization,
  props: true,
  meta: {
    menuItemIndex: '2',
    title:'Organization'
  }
},
  {
    path: '/organization/:organizationId/users/:userId([A-Za-z0-9\\/+]+=|[0-9A-Fa-f\\-]{36})',
    component: OrganizationUserProfile,
    name: 'OrganizationUserProfile',
    props: true,
    meta: {
      menuItemIndex: '2',
      title: 'Organization User Profile'
    }
  },
  {
    path: '/admin/organization/:organizationId/payment',
    component: PaymentIndex,
    name: 'OrganizationPayment',
    meta: {
      title: 'Plan & Payment'
    }
  },
  {
    path: '/organization/:organizationId/branches',
    component: Branch,
    name: 'Branch',
    props: true,
    meta: {
      menuItemIndex: '10',
      title: 'Branch list'
    }
  },
  {
    path: '/admin/organization/:organizationId/subscription/:paymentId/cancel',
    component: CancelSubscription,
    name: 'OrganizationCancelSubscription',
    meta: {
      title: 'Plan & Payment'
    }
  },
  {
    path: '/admin/organization/:organizationId/subscription/:paymentId/details',
    component: PaymentDetail,
    name: 'OrganizationPaymentDetail',
    meta: {
      title: 'Plan & Payment'
    }
  },
]
